import { Box, Checkbox, FormControlLabel, Stack, useMediaQuery } from '@mui/material'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FunctionComponent, SetStateAction, useContext, useEffect, useState } from 'react';
import { IPostEmailCampaign } from '../../../../modules/survey/shared-services/email-campaign/email-campaign.model';
import { DialogSaveButtons } from '../../miscellaneous-components/dialog-save-buttons';
import { IProject } from '../../../../shared/services/project/project.model';
import ProjectService from '../../../../shared/services/project/project.service';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { TooltipButton } from '../../miscellaneous-components/tooltip-button';
import gaiaTheme from '../../../../root-components/theme';
import { useIsReportPeriodLocked } from '../../../../hooks/use-is-report-period-locked';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';

export const EmissionsEmailCampaignContentForm: FunctionComponent<{
  newSurvey: IPostEmailCampaign,
  setNewSurvey: React.Dispatch<SetStateAction<any>>,
  handleNext?: () => void,
  submitSchedule?: (values?: Partial<IPostEmailCampaign>) => void,
  isSubmitted?: number;
  isEditPage?: boolean,
  isEditPageSubmitting?: boolean,
}> = ({
  newSurvey,
  setNewSurvey,
  handleNext,
  submitSchedule,
  isSubmitted,
  isEditPage = false,
  isEditPageSubmitting
}) => {
    //Services
    const userDetailsContext = useContext(UserDetailsContext)
    const organisation = userDetailsContext.userDetails?.organisation
    const projectService = ProjectService.getInstance()
    const screenLabelsContext = useContext(ScreenLabelsContext)
    //Hooks
    const isReportPeriodLocked = useIsReportPeriodLocked()
    //State
    const [formRendered, setFormRendered] = useState<boolean>(false);
    const [projects, setProjects] = useState<IProject[]>()
    //Layout
    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));

    useEffect(() => {
      projectService.getAllActive()
        .then(response => {
          setProjects(response)
        })
        .catch(err => console.log(err))
    }, [])

    useEffect(() => {
      if (formRendered && !isEditPage) {
        formik.submitForm();
      }
      setFormRendered(true)
    }, [isSubmitted])

    const employeeCommuteSchema = Yup.object().shape({
      includeProjects: Yup.boolean(),
    })

    const formik = useFormik({
      initialValues: {
        includeProjects: newSurvey.includeProjects,
      },
      validationSchema: employeeCommuteSchema,
      onSubmit: (values) => {
        setNewSurvey({
          ...newSurvey,
          includeProjects: values.includeProjects,
        })
        if (handleNext) {
          handleNext()
        }
        if (submitSchedule) {
          submitSchedule(values)
        }
      }
    });

    const cancelHandler = () => {
      formik.resetForm();
    }

    return (
      <Box component='form' onSubmit={formik.handleSubmit}>
        {projects &&
          <Stack display='flex' flexDirection='row' sx={{ mb: 3 }}>
            <FormControlLabel
              name='includeProjects'
              label={`Include ${screenLabelsContext.getLabel('project', { plural: false})} level commuting data`}
              control={
                <Checkbox
                  disabled={!organisation?.enableProjects || projects.length === 0 || isReportPeriodLocked === true}
                  onChange={formik.handleChange}
                  checked={formik.values.includeProjects}
                />} />
            {!isMobileMode && (!organisation?.enableProjects || projects.length === 0) && <TooltipButton
              text={`Requires ${screenLabelsContext.getLabel('project', { plural: true })} to be enabled and at least one ${screenLabelsContext.getLabel('project', { plural: false })} added`}
              placement='right'
            />}
          </Stack>}
        {isEditPage &&
          <Stack direction='row' spacing={2} alignItems='center' justifyContent='flex-end' sx={{ mt: 3 }}>
            <DialogSaveButtons
              isForm={true}
              isSubmitting={isEditPageSubmitting}
              cancelHandler={cancelHandler}
              submitHandler={formik.submitForm}
              disableSaveButton={isReportPeriodLocked === true}
              disableCancelButton={isReportPeriodLocked === true}
            />
          </Stack>}
      </Box>
    )
  }